import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Carousel from './Carousel';
import Display from './Display';
import ProductIntro from './ProductIntro';
import ApplicablePeople from './ApplicablePeople';
import News from './News';
import Footer from './Footer';
import FloatingSidebar from './FloatingSidebar';

const HomePage: React.FC = () => {
  const location = useLocation();

  // 处理从其他页面跳转回来时的滚动定位
  useEffect(() => {
    if (location.state?.scrollTo) {
      const elementId = location.state.scrollTo;
      // 延迟执行确保DOM完全渲染
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          const header = document.querySelector('.header') as HTMLElement;
          const headerHeight = header ? header.offsetHeight : 0;
          const elementPosition = element.offsetTop - headerHeight - 20;
          
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location.state]);

  return (
    <div className="App">
      <Header />
      <Carousel />
      <ProductIntro />
      <ApplicablePeople />
      <Display />
      <News />
      <Footer />
      <FloatingSidebar />
    </div>
  );
};

export default HomePage; 